import React from 'react';
import Layout from '../../components/Layout/Layout';
import VideoPreview from '../../components/VideoPreview/VideoPreview';
import styles from './VideoPreviewPage.module.css';

const VideoPreviewPage = () => {
  return (
    <Layout width="1440px">
      <div className={styles.previewGrid}>
        <VideoPreview
          companyId="6f10ce3e-cc47-4fbb-a3e8-155263bf4372"
          size="Desktop 1440"
          autoPlay={true}
          controls={false}
          loop={true}
        />
      </div>
    </Layout>
  );
};

export default VideoPreviewPage;